//HEADER USP CAROUSEL
var x=jQuery.noConflict();
x(window).bind("load", function() {

    document.getElementById("dz_collections_inner").style.display = "none";
  
	window_resize();

	x(window).resize(function() {
		window_resize();
	});

	function window_resize() {
      
        if ( x(window).innerWidth() < 976 ) {
        //    function insertAfter(referenceNode, newNode) {
        //      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
       //     }
       //     let dz_bestseller = document.getElementById("dz_bestseller");
       //     let column_center = document.getElementById("column_center");

        //    insertAfter(column_center, dz_bestseller);
          
        //    dz_bestseller.style.display = "block";
        //    dz_bestseller.style.clear = "both";

            document.getElementById("dz_collections_inner").style.display = "none";

            // Mobile Menu Show & Hide
            document.getElementById("dz_menutitle").onclick = function() {
                let menu_list = document.getElementById("dz_collections_inner");

                if (menu_list.style.display == 'none') {
                  menu_list.style.display = 'block';
                } else {
                  menu_list.style.display = 'none';
                }
            }
          
        }else{

            document.getElementById("dz_collections_inner").style.display = "block";

            // Mobile Menu Show & Hide
            document.getElementById("dz_menutitle").onclick = function() {
                let menu_list = document.getElementById("dz_collections_inner");

                if (menu_list.style.display == 'none') {
                  menu_list.style.display = 'block';
                } else {
                  menu_list.style.display = 'block';
                }
            }
          
       //     function insertAfter(referenceNode, newNode) {
       //       referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
       //     }
       //     let dz_bestseller = document.getElementById("dz_bestseller");
       //     let dz_collections = document.getElementById("dz_collections");
       //         insertAfter(dz_collections, dz_bestseller);
       //     dz_collections.style.display = "block";
        }

        if ( x(window).innerWidth() < 464 ) {
            let dz_menutitle = document.getElementById("dz_menutitle");
            dz_menutitle.childNodes[1].innerHTML = "Menu";
        }else{
            dz_menutitle.childNodes[1].innerHTML = "Shop by category";
        }
	}
});
